/**
 * Created by Udara Prabath
 * Date: 10/20/2020
 * Using: IntelliJ IDEA
 */

import * as actionTypes from "./actionType";

export const fetchTeachers = (data) => {
    return {
        type: actionTypes.FETCH_TEACHERS,
        value: data
    }
};